import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './PageLoader.css';

const PageLoader = ({ forceShow = false }) => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // If forceShow is true, show loader immediately
    if (forceShow) {
      setLoading(true);
      return;
    }

    // Reset and start loading on route change
    setLoading(true);

    // Complete loading after 2 seconds
    const completeTimer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => {
      clearTimeout(completeTimer);
    };
  }, [location.pathname, forceShow]);

  // If forceShow is provided, use it directly
  if (forceShow) {
    return (
      <div className="page-loader-overlay">
        <div className="page-loader-content">
          <div className="page-loader-spinner">
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
          </div>
          <p className="page-loader-text">Loading...</p>
        </div>
      </div>
    );
  }

  if (!loading) return null;

  return (
    <div className="page-loader-overlay">
      <div className="page-loader-content">
        <div className="page-loader-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <p className="page-loader-text">Loading...</p>
      </div>
    </div>
  );
};

export default PageLoader;
